import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { get_orders } from '../../store/reducers/orderReducer'

const Orders = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userInfo } = useSelector(state => state.auth)
    const { myOrders, order } = useSelector(state => state.order)
    const [state, setState] = useState('all')


    useEffect(() => {
        dispatch(get_orders({ status: state, customerId: userInfo.id }))
    }, [state])

    const redirect = (ord) => {
        let items = 0;
        for (let i = 0; i < ord.products.length; i++) {
            items = ord.products[i].quantity + items
        }
        navigate('/payment', {
            state: {
                price: ord.price,
                items,
                orderId: ord._id
            }
        })
    }

    return (
        <>
            <div className='bg-white p-4 rounded-md xs:hidden'>
                <div className='flex justify-between items-center'>
                    <h2 className='text-xl font-semibold text-slate-600'>My Orders</h2>
                    <select className='outline-none px-3 py-1 border rounded-md text-slate-600' value={state} onChange={(e) => setState(e.target.value)}>
                        <option value="all">--order status---</option>
                        <option value="placed">Placed</option>
                        <option value="pending">Pending</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="warehouse">Warehouse</option>
                    </select>
                </div>
                <div className='pt-4'>
                    <div className='relative overflow-x-auto'>
                        <table className='w-full text-sm text-left text-gray-500'>
                            <thead className='text-xs text-gray-700 uppercase bg-gray-50'>
                                <tr>
                                    <th scope='col' className='px-6 py-3'>Order Id</th>
                                    <th scope='col' className='px-6 py-3'>Price</th>
                                    <th scope='col' className='px-6 py-3'>Payment status</th>
                                    <th scope='col' className='px-6 py-3'>Order status</th>
                                    <th scope='col' className='px-6 py-3'>Action</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    myOrders.map((o, i) => <tr key={i} className='bg-white border-b'>
                                        <td scope='row' className='px-6 py-4 font-medium whitespace-nowrap'>{o._id}</td>
                                        <td scope='row' className='px-6 py-4 font-medium whitespace-nowrap'>Rs.{o.price}</td>
                                        <td scope='row' className='px-6 py-4 font-medium whitespace-nowrap'>{o.payment_status}</td>
                                        <td scope='row' className='px-6 py-4 font-medium whitespace-nowrap'>{o.delivery_status}</td>
                                        <td scope='row' className='px-6 py-4'>
                                            <Link to={`/dashboard/order/details/${o._id}`}>
                                                <span className='bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded'>view</span>
                                            </Link>
                                            {
                                                o.payment_status !== 'paid' && <span onClick={() => redirect(o)} className='bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded cursor-pointer'>Pay Now</span>
                                            }
                                        </td>
                                    </tr>)
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className='hidden xs:block pt-4'>
                {myOrders.map((o, i) => (
                    <div key={i} className='bg-white p-4 mb-6 rounded-md shadow-sm'>
                        <div className='flex justify-between items-center mb-2 relative'>
                            <h3 className='text-sm font-semibold text-slate-600'>Order #{o._id}</h3>
                            <span className={`absolute right-[-20px] top-[-30px] text-sm px-2 py-1 rounded ${o.payment_status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                {o.payment_status}
                            </span>
                        </div>
                        <p className='text-sm text-gray-500'>Price: Rs.{o.price}</p>
                        <p className='text-sm text-gray-500'>Order Status: {o.delivery_status}</p>
                        <div className='mt-2'>
                            <Link to={`/dashboard/order/details/${o._id}`}>
                                <span className='bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded'>View</span>
                            </Link>
                            {o.payment_status !== 'paid' && (
                                <span onClick={() => redirect(o)} className='bg-green-100 text-green-800 text-sm whitespace-nowrap font-normal mr-2 px-2.5 py-[1px] rounded cursor-pointer'>Pay Now</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Orders